import { PALETTE } from '../palette.js';
import Beacon, { BeaconSlowNote } from './Beacon.jsx';

export const DEFAULT_PROTECTED_PAGE_LOADING_TITLE = 'Loading workspace data';
export const DEFAULT_PROTECTED_PAGE_LOADING_BODY =
  'Checking your session, company context, and permissions before showing this page.';

// `slowAfterMs` is only set by pages whose load waits on a provider (Meta
// reports, leads); the workspace/session loads never show the slow line.
export default function ProtectedPageLoader({
  title = DEFAULT_PROTECTED_PAGE_LOADING_TITLE,
  body = DEFAULT_PROTECTED_PAGE_LOADING_BODY,
  minHeight = 'clamp(320px, 62vh, 640px)',
  style = {},
  slowAfterMs = null,
}) {
  return (
    <div
      className="protected-page-loader"
      role="status"
      aria-live="polite"
      aria-busy="true"
      style={{ ...loaderLayoutStyle, minHeight, ...style }}
    >
      <Beacon size="page" delayMs={0} slowAfterMs={null} />
      <div style={{ display: 'grid', gap: 6, justifyItems: 'center' }}>
        <div style={titleStyle}>{title}</div>
        <div style={bodyStyle}>{body}</div>
        {slowAfterMs === null ? null : <BeaconSlowNote slowAfterMs={slowAfterMs} />}
      </div>
    </div>
  );
}

const loaderLayoutStyle = {
  display: 'grid',
  alignContent: 'center',
  justifyItems: 'center',
  gap: 14,
  textAlign: 'center',
  width: '100%',
  boxSizing: 'border-box',
  marginInline: 'auto',
  padding: 'clamp(24px, 5vw, 56px) 20px',
};

const titleStyle = {
  color: PALETTE.ink,
  fontSize: 17,
  fontWeight: 800,
};

const bodyStyle = {
  maxWidth: 430,
  color: PALETTE.ink2,
  fontSize: 13,
  lineHeight: 1.5,
};
